module.exports = __webpack_public_path__ + "static/media/grimacing-face-svgrepo-com.8e712065.svg";